import { ContentfulTextNoteType } from 'ContentfulDefaults/types/_shared';

export const alexGoReviewNote: {
  alex_go_review_note: ContentfulTextNoteType[];
} = {
  alex_go_review_note: [
    {
      plan_year: '2026',
      supplemental_plan_type: null,
      short_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value: '¡Podemos incluir una nota de texto personalizada aquí de hasta 140 caracteres!',
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
      long_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value: 'Información adicional puede ir aquí, ¡hasta 5000 caracteres!',
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
      button_text: 'Leer más',
    },
  ],
};
